import { AbstractControl, ValidationErrors, ValidatorFn, ValidatorFn as _ValidatorFn } from '@angular/forms';

/**
 * Validator de grupo que torna `fatorConversao` obrigatório
 * quando `idUnidadeMedida` é diferente de `idUnidadeTributavel`.
 *
 * Deve ser aplicado no **FormGroup raiz** (ou no FormGroup que contém os três campos).
 *
 * Uso:
 * ```ts
 * this.form = this.fb.group({ ... }, { validators: fatorConversaoValidator() });
 * ```
 */
export function fatorConversaoValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
        const unidade = group.get('idUnidadeMedida')?.value;
        const unidTrib = group.get('idUnidadeTributavel')?.value;
        const fator = group.get('fatorConversao')?.value;

        const obrigatorio = unidTrib && unidade !== unidTrib;

        if (obrigatorio && (fator === null || fator === undefined || fator === 0 || fator === '')) {
            // Marca o erro no próprio campo para que o mat-error funcione
            group.get('fatorConversao')?.setErrors({ required: true });
            return { fatorConversaoObrigatorio: true };
        }

        // Remove o erro de required se a regra não se aplica mais
        // (preserva outros erros que possam existir)
        const errosAtuais = group.get('fatorConversao')?.errors;
        if (errosAtuais?.['required']) {
            const { required, ...restErrors } = errosAtuais;
            group.get('fatorConversao')?.setErrors(Object.keys(restErrors).length ? restErrors : null);
        }

        return null;
    };
}
